import { render, staticRenderFns } from "./exportPaperBtn.vue?vue&type=template&id=43a24c0c&scoped=true&"
import script from "./exportPaperBtn.vue?vue&type=script&lang=js&"
export * from "./exportPaperBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a24c0c",
  null
  
)

export default component.exports